<template>
  <div class="recaptcha-branding" v-html="$t('brandText')"></div>
</template>

<script>
export default {
  name: "RecaptchaBranding",
  i18n: {
    messages: {
      en: {
        brandText: 'This site is protected by reCAPTCHA and the Google\n' +
            '    <a href="https://policies.google.com/privacy">Privacy Policy</a> and\n' +
            '    <a href="https://policies.google.com/terms">Terms of Service</a> apply.'
      },
      ru: {
        brandText: 'Защищено reCAPTCHA и регулируется' +
            '    <a href="https://policies.google.com/privacy">Политикой <br> конфиденциальности</a> и' +
            '    <a href="https://policies.google.com/terms">Условиями предоставления услуг Google</a>.'
      }
    }
  }
}
</script>

<style lang="scss">
.recaptcha-branding {
  @apply mt-12 mb-12 mx-auto text-center text-text-ternary;
  width: 40rem;

  a {
    @apply text-text-label;
    transition: all .2s;

    &:hover {
      @apply text-red;
    }
  }
  @media(max-width: 767.98px){
    @apply mx-6 w-auto;
  }
}
</style>